import { Option } from "./common";

// Define the FilterRegistry type
export type FilterRegistry = {
	id: string;
	name: string;
	type: string;
	options: Option[];
	value: string;
};

// Define the emptyFilterRegistry initialization
export const emptyFilterRegistry: FiltersResponse = {
	filters: [],
};

export type FiltersResponse = {
	filters: Array<FilterRegistry>;
};
